export default __webpack_public_path__ + "static/media/startup.432a7353.mp3";